import { IsInt, IsNotEmpty, IsOptional, IsPositive, IsString } from 'class-validator'

export const BREAK_TYPE_OTHER_KEY = 'other'

export class BreakDto {
  @IsInt()
  @IsOptional()
  @IsPositive()
  id?: number

  @IsString()
  @IsNotEmpty()
  startDate!: string

  @IsString()
  @IsNotEmpty()
  endDate!: string

  @IsString()
  @IsOptional()
  comment?: string

  @IsInt()
  @IsNotEmpty()
  @IsPositive()
  typeId: number | undefined

  @IsString()
  @IsOptional()
  typeKey?: string

  @IsString()
  @IsOptional()
  typeTranslation?: string
}
